import { FormControl, IconButton, Input, InputAdornment, InputLabel } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import passwords from "../../../../../assets/Images/possword.png";
import React from "react";

interface Props {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  showPassword: boolean;
  handleClickShowPassword: () => void;
  handleMouseDownPassword: (e: React.MouseEvent<HTMLButtonElement>) => void;
  passwordRef: React.RefObject<HTMLInputElement>;
}

const PasswordField = ({ value, onChange, onKeyPress, showPassword, handleClickShowPassword, handleMouseDownPassword, passwordRef }: Props) => (
  <FormControl sx={{ mt: 2.5 }} variant="standard" fullWidth>
    <InputLabel htmlFor="password">Password</InputLabel>
    <Input
      id="password"
      type={showPassword ? "text" : "password"}
      value={value}
      onChange={onChange}
      placeholder="Enter your password"
      onKeyPress={onKeyPress}
      disableUnderline
      inputRef={passwordRef}
      sx={{
        "& input::placeholder": {
          fontSize: "12px",
          color: "#999", 
          opacity: 1, 
        },
      }}
      startAdornment={
        <InputAdornment position="start">
          <img src={passwords} className="loginFieldIcon" alt="" />
        </InputAdornment>
      }
      endAdornment={
        <InputAdornment position="end">
          <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      }
    />
  </FormControl>
);

export default PasswordField;
